module.exports = __webpack_public_path__ + "static/media/check-icon.85e879d1.svg";